import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { getStageTheme } from "./stageColorTheme";

interface CollegeSummary {
  college: string;
  total: number;
  completed: number;
  offered: number;
  selected: number;
  accepted: number;
  joined: number;
  selectionRate: number;
  joiningRate: number;
}

interface CollegeSummaryTableProps {
  data: CollegeSummary[];
  id?: string;
}

export function CollegeSummaryTable({ data, id }: CollegeSummaryTableProps) {
  const selectedTheme = getStageTheme("Selected");
  const offeredTheme = getStageTheme("Offered");
  const acceptedTheme = getStageTheme("Accepted");
  const joinedTheme = getStageTheme("Joined");

  return (
    <Card id={id}>
        <CardHeader>
          <CardTitle>College Wise Summary</CardTitle>
          <CardDescription>
          Candidate volume, completion, and conversion performance by college
          </CardDescription>
        </CardHeader>
        <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>College</TableHead>
              <TableHead className="text-right">Total</TableHead>
              <TableHead className="text-right">Completed</TableHead>
              <TableHead className={`text-right ${selectedTheme.text}`}>Selected</TableHead>
              <TableHead className={`text-right ${offeredTheme.text}`}>Offered</TableHead>
              <TableHead className={`text-right ${acceptedTheme.text}`}>Accepted</TableHead>
              <TableHead className={`text-right ${joinedTheme.text}`}>Joined</TableHead>
              <TableHead className="text-right">Selection Rate</TableHead>
              <TableHead className="text-right">Joining Rate</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} className="text-center text-muted-foreground">
                  No data available
                </TableCell>
              </TableRow>
            ) : (
              data.map((row) => (
                <TableRow key={row.college}>
                  <TableCell className="font-medium">{row.college}</TableCell>
                  <TableCell className="text-right">{row.total}</TableCell>
                  <TableCell className="text-right">{row.completed}</TableCell>
                  <TableCell className="text-right">
                    <span className={`inline-flex min-w-9 items-center justify-center rounded-md px-2 py-1 text-xs font-semibold ${selectedTheme.tint}`}>
                      {row.selected}
                    </span>
                  </TableCell>
                  <TableCell className="text-right">
                    <span className={`inline-flex min-w-9 items-center justify-center rounded-md px-2 py-1 text-xs font-semibold ${offeredTheme.tint}`}>
                      {row.offered}
                    </span>
                  </TableCell>
                  <TableCell className="text-right">
                    <span className={`inline-flex min-w-9 items-center justify-center rounded-md px-2 py-1 text-xs font-semibold ${acceptedTheme.tint}`}>
                      {row.accepted}
                    </span>
                  </TableCell>
                  <TableCell className="text-right">
                    <span className={`inline-flex min-w-9 items-center justify-center rounded-md px-2 py-1 text-xs font-semibold ${joinedTheme.tint}`}>
                      {row.joined}
                    </span>
                  </TableCell>
                  <TableCell className="text-right">{row.selectionRate.toFixed(1)}%</TableCell>
                  <TableCell className="text-right">{row.joiningRate.toFixed(1)}%</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
